import React, { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '@/App';
import { Car, Loader2 } from 'lucide-react';

/**
 * Splash Screen - Tela inicial do app
 * Verifica sessão ativa e redireciona automaticamente
 */
export default function SplashScreen() {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Simular tempo mínimo de splash (melhor UX)
    const timer = setTimeout(() => {
      setChecking(false);
      
      if (user) {
        // Usuário logado - redirecionar para área correta
        switch (user.user_type) {
          case 'client':
            navigate('/client/dashboard', { replace: true });
            break;
          case 'provider':
            navigate('/provider/services', { replace: true });
            break;
          case 'admin':
            navigate('/admin/dashboard', { replace: true });
            break;
          default:
            navigate('/', { replace: true });
        }
      } else {
        // Não logado - ir para landing
        navigate('/', { replace: true });
      }
    }, 1500); // 1.5 segundos de splash

    return () => clearTimeout(timer);
  }, [user, navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 flex flex-col items-center justify-center">
      {/* Logo */}
      <div className="relative mb-8">
        <div className="absolute inset-0 bg-primary/20 blur-3xl rounded-full"></div>
        <div className="relative bg-white rounded-2xl p-6 shadow-2xl">
          <Car className="w-16 h-16 text-primary" />
        </div>
      </div>
      
      {/* Nome do App */}
      <h1 className="text-4xl font-bold text-white mb-2">JATOO</h1>
      <p className="text-slate-400 mb-8">Seu lava-jato favorito</p>
      
      {/* Loading */}
      {checking && (
        <div className="flex items-center gap-2 text-slate-400">
          <Loader2 className="w-5 h-5 animate-spin" />
          <span>Verificando sessão...</span>
        </div>
      )}
      
      {/* Versão */}
      <p className="absolute bottom-8 text-slate-600 text-sm">v1.0.0</p>
    </div>
  );
}
